import React from 'react';

/**
 * Skeleton — shimmer loading placeholder (Section 3.9).
 * Soft animated shimmer, never a static gray block.
 */
export function Skeleton({ className = '', style }: { className?: string; style?: React.CSSProperties }) {
  return <div className={`skeleton ${className}`} style={style} aria-hidden="true" />;
}

/** A row-shaped skeleton used inside lists and tables. */
export function SkeletonRow({ lines = 1, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`space-y-3 py-2 ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-full shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3.5 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Grid of skeleton cards (used for dashboard stat rows while loading). */
export function SkeletonCardGrid({ count = 4 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-6" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="stat-card">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-3 w-24 mt-3" />
        </div>
      ))}
    </div>
  );
}
